import React from 'react'
import Link from 'next/link'
import classes from '@src/styles/relatedServices.module.css'

type ServiceLink = {
  label: string
  href: string
  description: string
}

type RelatedServicesProps = {
  services: ServiceLink[]
}

function RelatedServices({ services }: RelatedServicesProps) {
  return (
    <section className={classes.container}>
      <h2 className={classes.heading}>Related Services</h2>
      <div className={classes.grid}>
        {services.map((service) => (
          <Link key={service.href} href={service.href} className={classes.card}>
            <h3 className={classes.cardTitle}>{service.label}</h3>
            <p className={classes.cardDescription}>{service.description}</p>
          </Link>
        ))}
      </div>
    </section>
  )
}

export default RelatedServices
